/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const regenerateUserQueueV1DataSchema = z.object({
  deletedCount: z.number().int(),
  newCount: z.number().int(),
});

export type IRegenerateUserQueueV1Data = z.infer<typeof regenerateUserQueueV1DataSchema>;

export const regenerateUserQueueV1ResponseSchema = createApiResponseSchema(
  regenerateUserQueueV1DataSchema,
) as z.ZodSchema<IAPI<IRegenerateUserQueueV1Data>>;
